
// 预案管理  信息录入
import requests from '../request'

// 分页查询预案
export const reserveplan_pagelist = (data) => {
  data = {
    ...data,
    code: JSON.parse(localStorage.getItem('unitInfo')).strCode,
    strUserGuid:localStorage.getItem('userId'),
    userRoleList:JSON.parse( localStorage.getItem('userRoleLists'))
  }
  return requests({
    url: '/api/plan/reserveplan/pagelist',
    method: 'post',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

//新增预案
export const reserveplanAdd = (data) => {
  return requests({
    url: '/api/plan/reserveplan/add',
    method: 'post',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

//分页查询法律法规
export const rulesregulation_pagelist = (data) => {
  return requests({
    url: '/api/plan/rulesregulation/pagelist',
    method: 'post',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

//获取预案详情
export const reserveplan_get = (params) => {
  return requests({
    url: '/api/plan/reserveplan/get',
    method: 'get',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//编辑预案
export const reserveplan_update = (data) => {
  return requests({
    url: '/api/plan/reserveplan/update',
    method: 'post',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//演练周期 下拉框
export const getCycleOptionsAPI = (data) => {
  return requests({
    url: '/api/dictionary/type/get',
    method: 'get',
    params: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}


// 预案审核通过
export const approvalPassAPI = (data) => {
  return requests({
    url: '/api/plan/reserveplan/approval/pass',
    method: 'post',
    data: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 预案审核驳货
export const rejectAPI = (data) => {
  return requests({
    url: '/api/plan/reserveplan/approval/rejected',
    method: 'post',
    data: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 预案发布
export const releaseAPI = (data) => {
  return requests({
    url: '/api/plan/reserveplan/release',
    method: 'post',
    data: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 预案撤回
export const revocationAPI = (data) => {
  return requests({
    url: '/api/plan/reserveplan/undorelease',
    method: 'post',
    data: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

